import React from "react";

const Card = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className = '', ...props }, ref) => 
  React.createElement('div', {
    ref,
    className: `rounded-lg border bg-white shadow-sm ${className}`,
    ...props
  })
)
Card.displayName = "Card"

const CardHeader = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className = '', ...props }, ref) => 
  React.createElement('div', {
    ref,
    className: `flex flex-col space-y-1.5 p-6 ${className}`,
    ...props
  })
)
CardHeader.displayName = "CardHeader"

const CardTitle = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLHeadingElement>
>(({ className = '', ...props }, ref) => 
  React.createElement('h3', {
    ref,
    className: `text-2xl font-semibold leading-none tracking-tight ${className}`,
    ...props
  })
)
CardTitle.displayName = "CardTitle"

const CardDescription = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ className = '', ...props }, ref) => 
  React.createElement('p', {
    ref,
    className: `text-sm text-gray-600 ${className}`,
    ...props
  })
)
CardDescription.displayName = "CardDescription"

const CardContent = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className = '', ...props }, ref) => 
  React.createElement('div', {
    ref,
    className: `p-6 pt-0 ${className}`,
    ...props
  })
)
CardContent.displayName = "CardContent"

const CardFooter = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className = '', ...props }, ref) => 
  React.createElement('div', {
    ref,
    className: `flex items-center p-6 pt-0 ${className}`,
    ...props
  })
)
CardFooter.displayName = "CardFooter"

export { Card, CardHeader, CardFooter, CardTitle, CardDescription, CardContent }
